import { EventEmitter, Injectable, Output } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';

@Injectable()
export class SharedHandlerService {

  @Output() readonly paginate: EventEmitter<any[]> = new EventEmitter();

  applyPagination(paginatedData: any[]): void {
    this.paginate.emit(paginatedData);
  }

}
